import { atom } from 'jotai'
import { ChannelPaymentStep } from 'types/payments'

export const channelPaymentStepAtom = atom<ChannelPaymentStep>(ChannelPaymentStep.CONTACT)
channelPaymentStepAtom.debugLabel = 'channel-payment-step'

export const channelPaymentUrlAtom = atom('')
channelPaymentUrlAtom.debugLabel = 'channel-payment-url'
